

/**
 * Get the cart contents from the Shopify storefront using the Ajax API.
 */
export const getCart = (url, options) => {

  return new Promise((resolve, reject) => {

    const url = '/cart.js';

    fetch(url)
    .then(function(response) {
      return response.json();
    })
    .then((res) => {
      resolve(res);
    })
    .catch((err) => {
      resolve(err);
    });

  });

};

/**
 * Add the product to the cart using the Shopify Ajax API
 */
export const addToCart = (builderCartItem) => {

  return new Promise((resolve, reject) => {

    fetch('/cart/add.js', {
      body: JSON.stringify(builderCartItem),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
      },
      method: 'POST'
    })
    .then((res) => {
      resolve(res);
    })
    .catch((err) => {
      reject(err);
    });

  });

}

const getDiscountRequirements = (cart, builderCartItem) => {

  let discountAmountRequirement = 0;

  let discountAmount = 0;

  let discountVariantRequirement = [];


  /** Find each item in the cart that has a discount already applied */
  let discountLines = cart.items.map((item, index) => {

    if (!item.properties || !item.properties._gs_bundle_discount || parseInt(item.properties._gs_bundle_discount) <= 0) return false;

    discountAmount += parseInt(item.properties._gs_bundle_discount);

    return item;

  });

  if (builderCartItem.properties && builderCartItem.properties._gs_bundle_discount && builderCartItem.properties._gs_bundle_discount > 0) {

    discountAmount += parseInt(builderCartItem.properties._gs_bundle_discount);

    discountLines.push(builderCartItem);

  }


  /** Get the variant ids, and total dollar value of each of the items that has a discount */

  discountLines.map((item, index) => {

    // Skip undefined or false items
    if (typeof(item) == 'undefined' || !item) return;

    // Get the amount requirement from the main line item
    discountAmountRequirement += parseInt(item.price * item.quantity);

    // Get the amount requirement from the bundle prices
    discountAmountRequirement += item.properties._gs_bundle_prices.reduce((accumulator, currentValue) => accumulator + (currentValue * item.quantity), 0);

    if (item.variant_id) {
      discountVariantRequirement.push(item.variant_id); // Handles builders in the cart already.
    } else {
      discountVariantRequirement.push(item.id); // Handles the new builder
    }

    // Merge the bundle ids with the other requirements
    item.properties._gs_bundle_ids.map((value, index) => {
      discountVariantRequirement.push(parseInt(value));
    });

  });


  // Ensure the results are unique.
  discountVariantRequirement = discountVariantRequirement.filter((value, index, self) => {
    return self.indexOf(value) === index
  });

  return {
    discountVariantRequirement: discountVariantRequirement,
    discountAmountRequirement: discountAmountRequirement,
    discountAmount: discountAmount
  }


}

const setCookie =(name,value,days) => {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

/**
 * Generate a discount code dependent on existing builders, and the new builder item
 */
export const generateDiscount = (cart, builderCartItem) => {

  let requirements = getDiscountRequirements(cart, builderCartItem);

  return new Promise((resolve, reject) => {

    let url = `/a/gs/api/builder/discount`;

    requirements.shop = Shopify.shop;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(requirements)
    })
    .then(function(response) {
      return response.json();
    })
    .then((res) => {
      if (res.discount_code) {
        setCookie('box_builder_code', res.discount_code, 7);
      }
      //TODO: SET THE DISCOUNT CODE VALUE AS the  "discount" COOKIE.
      resolve(res);
    })
    .catch((err) => {
      resolve(err);
    });

  });

}
